import lazy from 'utils/lazy';

export const Login = lazy(() => import('./Login'));
